import { render, staticRenderFns } from "./ProjectForumThread.vue?vue&type=template&id=51da952e&scoped=true"
import script from "./ProjectForumThread.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectForumThread.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProjectForumThread.vue?vue&type=style&index=0&id=51da952e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51da952e",
  null
  
)

export default component.exports